import React, { memo, useCallback } from "react";
import { slides, SlideKey } from "../config/slides";
import { useNavigation } from "../context/NavigationContext";

export interface NavigationProps {
  activeSlide?: SlideKey;
}

const Navigation: React.FC<NavigationProps> = ({
  activeSlide = "home",
}) => {
  const { scrollToIndex } = useNavigation();

  const handleNavigation = useCallback((hash: string, index: number) => {
    scrollToIndex(index);
    window.history.replaceState(null, "", hash);
  }, [scrollToIndex]);

  const linkStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 4,
    cursor: "pointer",
    textDecoration: "none",
  };

  return (
    <div
      style={{
        pointerEvents: "all",
        display: "flex",
        gap: 18,
        fontSize: 12,
        lineHeight: "1em",
        textAlign: "right",
        color: "black",
        alignItems: "center",
        justifyContent: "flex-end",
        marginLeft: "auto",
      }}
    >
      {slides.map((slide) => {
        const isActive = activeSlide === slide.key;
        const Icon = slide.icon;
        const slideIndex = slides.findIndex(s => s.key === slide.key);

        if (slide.type === "link") {
          return (
            <a
              key={slide.key}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                ...linkStyle,
                color: isActive ? (slide.iconColor || "#C82128") : "#2E2E2E",
                fontWeight: isActive ? "bold" : "normal",
              }}
              href={slide.url}
            >
              <Icon width={14} height={14} /> {slide.label}
            </a>
          )
        }

        return (
          <a
            key={slide.key}
            href={slide.hash}
            onClick={(e) => {
              e.preventDefault();
              handleNavigation(slide.hash || "", slideIndex);
            }}
            style={{
              ...linkStyle,
              color: isActive ? (slide.iconColor || "#C82128") : "#2E2E2E",
              fontWeight: isActive ? "bold" : "normal",
            }}
          >
            <Icon
              fill={isActive ? (slide.iconColor || "currentColor") : "#414141ff"}
              width={14} height={14} /> {slide.label}
          </a>
        );
      })}
    </div>
  );
};

export default memo(Navigation);
